import { render, staticRenderFns } from "./bottomPagination.vue?vue&type=template&id=ea3040f4&scoped=true&"
import script from "./bottomPagination.vue?vue&type=script&lang=js&"
export * from "./bottomPagination.vue?vue&type=script&lang=js&"
import style0 from "./bottomPagination.vue?vue&type=style&index=0&id=ea3040f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3040f4",
  null
  
)

export default component.exports